// Mock data for Avid Branding appointment booking system

export const timeSlots = [
  '9:00 AM',
  '9:30 AM', 
  '10:00 AM',
  '10:30 AM',
  '11:00 AM',
  '11:30 AM',
  '12:00 PM',
  '12:30 PM',
  '1:00 PM',
  '1:30 PM',
  '2:00 PM',
  '2:30 PM',
  '3:00 PM',
  '3:30 PM',
  '4:00 PM',
  '4:30 PM'
];

export const appointmentTypes = [
  'Brand Consultation (30 min)',
  'Logo Design Discussion (30 min)',
  'Apparel Samples Review (30 min)',
  'Custom Order Planning (30 min)',
  'General Inquiry (30 min)'
];

// Mock function to simulate appointment submission
export const submitAppointment = async (appointmentData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock appointment submitted:', appointmentData);
      resolve({
        success: true,
        message: 'Appointment request received! We will contact you within 24 hours to confirm your appointment.',
        appointmentId: `APT-${Date.now()}`
      });
    }, 1000);
  });
};

// Mock business info
export const businessInfo = {
  name: 'Avid Branding',
  company: 'A division of DA-12 Corp',
  address: '4-246372 Hockley Rd, Orangeville, ON',
  phones: ['519-938-8959'],
  hours: 'Monday - Saturday, By Appointment',
  services: [
    'Custom T-shirts & Hoodies',
    'Embroidered Apparel',
    'Custom Mugs & Promotional Items',
    'Logo Design & Brand Consultation',
    'Free Samples Available'
  ]
};